import React, { useState } from "react"

const GrandOpen = ({ activeAccordion }) => {
   const [activeIndex, setActiveIndex] = useState(activeAccordion ? 0 : null);

   const toggleAccordion = () => {
      setActiveIndex((prevActiveIndex) => (prevActiveIndex === null ? 0 : null))
   }

   return (
      <div className='GrandOpen'>
         <div className={`accordion-item ${activeIndex === 0 ? "active" : ""}`}>
            <h1 onClick={toggleAccordion}>
               <img src={require("../../img/news/news00.jpg")} alt="" />
               [LCDC SEOUL]   GRAND OPENING
            </h1>
            <span>2022-03-10</span>
            {activeIndex === 0 && (
            <div>
               <img src={require("../../img/news/news00.jpg")} alt="" />
               <p style={{textAlign:'center', fontWeight:'bold'}}>LCDC SEOUL이 12월 3일 오픈합니다.</p>
               <p>'LE CONTE DES CONTES 이야기 속의 이야기'의 앞 글자를 딴 'LCDC SEOUL'은 다양한 이야기를 가지고 있는 브랜드가 모여새로운 이야기를 만들어내는 복합문화공간입니다.</p>
               <p className="mb50">여러 단편 소설들이 모여 하나의 단편집을 이루듯 크고 작은 독립적인 브랜드가 서로 협력하여 각자의 이야기를 만들고 크게는 하나의 이야기로 펼쳐집니다. 어느 한 쪽이 두드러지기 보다는, 모든 요소가 동등하게 어우러지는 LCDC SEOUL 만의 세계관을 경험해보세요.</p>

               <span>*OPENING HOUR: 11:00AM~ 21:00PM</span>
               <span>*ADDRESS: 서울시 성동구 연무장17길 10</span>
               <span className="mb150">*샵 별로 운영 시간이 상이합니다. 자세한 안내는 INFORMATION 메뉴 확인 부탁 드립니다.</span>

            </div>
            )}
         </div>
      </div>
   )
}

export default GrandOpen
